import analysisRestService from '../services/analysis/AnalysisRestService'
import { todayLocalDate } from '../services/common/UtilsFunctions'

const state = {
  dialogActived: false,
  analysis: {},
  defaultItem: {
    id: -1,
    zaranda: null,
    zarandas: [],
    caidaZaranda: null,
    incomestible: null,
    terron: null,
    manchado: null,
    partido: null,
    helado: null,
    chuzo: null,
    tiempoCoccion: null,
    roido: null,
    picadoCampo: null,
    contrastante: null,
    leveA: null,
    leveB: null,
    descorticado: null,
    cascado: null,
    arrugado: null,
    revolcado: null,
    manchadoMaquina: null,
    puntaChaucha: null,
    pinto: null,
    bolita: null,
    oxidado: null,
    quebrado: null,
    brotado: null,
    venoso: null,
    decolorido: null,
    humedad: null,
    gramaje: null,
    hidratacion: null,
    analysisDate: todayLocalDate()
  }
}

const getters = {
  getAnalysis: state => state.analysis,
  isDialogActived: state => state.dialogActived,
  getDefaultItem: state => state.defaultItem
}

const actions = {
  async getAnalysis (context, id) {
    try {
      let data = await analysisRestService.getAnalysis(id)
      context.commit('setAnalysis', data)
    } catch (e) {
      console.log('Error fetching Analysis.')
    }
  },
  async saveAnalysis (context, analysisInfo) {
    let snackBarContent = {actived: true, message: 'Analisis Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      const saved = await analysisRestService.saveAnalysis(analysisInfo)
      context.commit('setAnalysis', saved)
      context.commit('incomeModule/updateAnalysis', {incomeId: analysisInfo.incomeId, analysis: saved}, {root: true})
      return saved
    } catch (error) {
      snackBarContent = {actived: true, message: error.response?.data?.message || 'No se pudo confirmar el guardado del análisis.', color: 'error'}
      throw error
    } finally {
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    }
  },
  setAnalysisData (context, itemData) {
    context.commit('setAnalysis', itemData)
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  }
}

const mutations = {
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setAnalysis (state, data) {
    state.analysis = data
  },
  setAnalysisDataAsDefaultItem (state) {
    state.analysis = state.defaultItem
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
